import { usePermission } from '@/shell/module-system'
import type { NavBadge } from '@/shell/module-system'
import { usePendingReviewCount } from './api/reviewQueries'

/**
 * Sidebar count of price reviews waiting for approval. Admin only: the count
 * endpoint is admin-gated, and approving is the admin's job, so a sales user
 * would see a number they can do nothing about.
 */
export function useReviewsNavBadge(): NavBadge | null {
  const isAdmin = usePermission('admin')
  const { data } = usePendingReviewCount(isAdmin)
  if (!isAdmin || !data?.count) return null
  return {
    count: data.count,
    tone: 'warning',
    title: `${data.count} price ${data.count === 1 ? 'review needs' : 'reviews need'} approval`,
  }
}
